<div>
    <h4>Discusi&oacute;n</h4>
    <div>
        <div style="display: flex; justify-content: center;">
            <mat-form-field>
                <mat-label><mat-icon>comment</mat-icon>Comentario</mat-label>
                <textarea aria-label="Comentario" matInput placeholder="Comentario" autocomplete="off" type="text"
                    [(ngModel)]="discusion.comentario" maxlength="200">
                </textarea>
            </mat-form-field>
            <button mat-raised-button type="button" (click)="guardar()"
                class="btn btn-just-icon btn-round btn btn-success"
                [disabled]="discusion.comentario == undefined || discusion.comentario == null">
                <i class="material-icons">add</i>
            </button>
        </div>
    </div>
</div>
<div *ngIf="listDiscucion.length > 0">
    <div *ngFor="let d of listDiscucion"  style="display: flex; justify-content: center;">
        <p>{{d.nombre_usuario}}</p>
        <mat-form-field>
            <mat-label><mat-icon>comment</mat-icon> {{d.fecha_registro | date: 'dd/MM/yyyy HH:mm:ss'}}</mat-label>
            <textarea [attr.aria-label]="d.fecha_registro | date: 'dd/MM/yyyy HH:mm:ss'" matInput placeholder="Comentario" autocomplete="off" type="text"
                [(ngModel)]="d.comentario" maxlength="200" name="commit+d.i">
            </textarea>
        </mat-form-field>
        <button mat-raised-button type="button" (click)="editar(d)"
                class="btn btn-just-icon btn-round btn btn-success"
                [disabled]="d.comentario == undefined || d.comentario == null">
                <i class="material-icons">edit</i>
        </button>
    </div>
</div>